import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer } from "recharts";

const MAX = { league_strength: 25, prestige: 20, titles: 30, impact: 15 };

export const PlayerRadar = ({ scores }) => {
  const data = [
    { axis: "League", value: scores?.league_strength || 0, max: MAX.league_strength },
    { axis: "Prestige", value: scores?.prestige || 0, max: MAX.prestige },
    { axis: "Titles", value: scores?.titles || 0, max: MAX.titles },
    { axis: "Impact", value: scores?.impact || 0, max: MAX.impact },
  ].map((d) => ({ ...d, normalised: Math.round((d.value / d.max) * 100) }));

  return (
    <div className="h-[300px] min-h-[300px] w-full min-w-[240px]" data-testid="player-radar-chart">
      <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 400, height: 300 }}>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="#27272a" />
          <PolarAngleAxis dataKey="axis" tick={{ fill: "#a1a1aa", fontSize: 11, letterSpacing: 1 }} />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar dataKey="normalised" stroke="#E32118" fill="#E32118" fillOpacity={0.28} strokeWidth={2} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export const ScoreTable = ({ scores, total }) => {
  const rows = [
    ["League Strength", scores?.league_strength || 0, 25],
    ["Club Prestige", scores?.prestige || 0, 20],
    ["Titles Won (weighted)", scores?.titles || 0, 20],
    ["Impact", scores?.impact || 0, 15],
  ];
  return (
    <table className="w-full text-sm" data-testid="player-score-table">
      <thead>
        <tr className="border-b border-zinc-800 text-left">
          <th className="py-2 overline font-bold">Criterion</th>
          <th className="py-2 overline font-bold text-right">Score</th>
          <th className="py-2 overline font-bold text-right">Max</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(([label, value, max]) => (
          <tr key={label} className="border-b border-zinc-900">
            <td className="py-3 text-zinc-300">{label}</td>
            <td className="py-3 text-right font-display text-lg text-white">{value}</td>
            <td className="py-3 text-right text-zinc-400">{max}</td>
          </tr>
        ))}
        <tr>
          <td className="py-3 font-display uppercase tracking-wide text-ochre">Total</td>
          <td className="py-3 text-right font-display text-2xl text-ochre">{total ?? 0}</td>
          <td className="py-3 text-right text-zinc-400">80</td>
        </tr>
      </tbody>
    </table>
  );
};
